import { InjectionKey } from 'vue'

const dialogKey: InjectionKey<Record<string, any>> = Symbol('dialog')

export { dialogKey }
